import { render, staticRenderFns } from "./Success.vue?vue&type=template&id=719e380a&"
import script from "./Success.vue?vue&type=script&lang=js&"
export * from "./Success.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/Mac/Desktop/Code/permtang/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../Users/Mac/Desktop/Code/permtang/frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCol,VIcon,VRow,VSpacer})
